<template>
  <div>
    <el-card class="mat12">
      <el-row>
        <el-col :span="6" class="media_col padding-tb10 flex_class" :class="{'contrast':history.name && history.name != staffDetail.name}">
          <span v-if="history.name && history.name != staffDetail.name">*</span>
          <h4 class="flex_shrink">姓名：</h4>
          <span
            :class="$store.getters.tagsView?'ellipsis':''"
            :title="staffDetail.name"
          >{{ staffDetail.name }}</span>
          <i class="el-icon-view view_history" v-popover:popover1 v-show="history.name && history.name != staffDetail.name"></i>
          <!-- 显示 -->
          <el-popover
            ref="popover1"
            placement="right"
            title="姓名："
            width="200"
            trigger="click"
            :content="history.name"
          ></el-popover>
        </el-col>
        <el-col :span="6" class="media_col padding-tb10 flex_class">
          <h4 class="flex_shrink">工号：</h4>
          <span :class="$store.getters.tagsView?'ellipsis':''" :title="staffDetail.id">{{staffDetail.id}}</span>
        </el-col>

        <el-col :span="6" class="media_col padding-tb10 flex_class" :class="{'contrast':history.sex && history.sex != staffDetail.sex}">
          <span v-if="history.sex && history.sex != staffDetail.sex">*</span>
          <h4 class="flex_shrink">性别：</h4>
          <span
            :class="$store.getters.tagsView?'ellipsis':''"
            :title="staffDetail.sex"
          >{{ staffDetail.sex }}</span>
          <i class="el-icon-view view_history" v-popover:popover3 v-show="history.sex && history.sex != staffDetail.sex"></i>
          <!-- 显示 -->
          <el-popover
            ref="popover3"
            placement="right"
            title="性别："
            width="200"
            trigger="click"
            :content="history.sex"
          ></el-popover>
        </el-col>
        <el-col :span="6" class="media_col padding-tb10 flex_class" :class="{'contrast':history.birthday && history.birthday != staffDetail.birthday}">
          <span v-if="history.birthday && history.birthday != staffDetail.birthday">*</span>
          <h4 class="flex_shrink">出生日期：</h4>
          <span
            :class="$store.getters.tagsView?'ellipsis':''"
            :title="staffDetail.birthday"
          >{{ staffDetail.birthday }}</span>
          <i class="el-icon-view view_history" v-popover:popover4 v-show="history.birthday && history.birthday != staffDetail.birthday"></i>
          <!-- 显示 -->
          <el-popover
            ref="popover4"
            placement="right"
            title="出生日期："
            width="200"
            trigger="click"
            :content="history.birthday"
          ></el-popover>
        </el-col>
        <el-col :span="6" class="media_col padding-tb10 flex_class" :class="{'contrast':history.idNum && history.idNum != staffDetail.idNum}">
          <span v-if="history.idNum && history.idNum != staffDetail.idNum">*</span>
          <h4 class="flex_shrink">身份证号：</h4>
          <span
            :class="$store.getters.tagsView?'ellipsis':''"
            :title="staffDetail.idNum"
          >{{ staffDetail.idNum }}</span>
          <i class="el-icon-view view_history" v-popover:popover5 v-show="history.idNum && history.idNum != staffDetail.idNum"></i>
          <!-- 显示 -->
          <el-popover
            ref="popover5"
            placement="right"
            title="身份证号："
            width="200"
            trigger="click"
            :content="history.idNum"
          ></el-popover>
        </el-col>
        <el-col :span="6" class="media_col padding-tb10 flex_class" :class="{'contrast':history.phone && history.phone != staffDetail.phone}">
          <span v-if="history.phone && history.phone != staffDetail.phone">*</span>
          <h4 class="flex_shrink">手机号：</h4>
          <span
            :class="$store.getters.tagsView?'ellipsis':''"
            :title="staffDetail.phone"
          >{{ staffDetail.phone }}</span>
          <i class="el-icon-view view_history" v-popover:popover6 v-show="history.phone && history.phone != staffDetail.phone"></i>
          <!-- 显示 -->
          <el-popover
            ref="popover6"
            placement="right"
            title="手机号："
            width="200"
            trigger="click"
            :content="history.phone"
          ></el-popover>
        </el-col>
        <el-col :span="6" class="media_col padding-tb10" :class="{'contrast':history.height && history.height != staffDetail.height}">
          <span v-if="history.height && history.height != staffDetail.height">*</span>
          <h4>身高：</h4>
          {{ staffDetail.height }}cm
          <i
            class="el-icon-view view_history"
            v-popover:popover7
            v-show="history.height && history.height != staffDetail.height"
          ></i>
          <!-- 显示 -->
          <el-popover
            ref="popover7"
            placement="right"
            title="身高："
            width="200"
            trigger="click"
            :content="history.height"
          ></el-popover>
        </el-col>
         <el-col :span="6" class="media_col padding-tb10" :class="{'contrast':history.weight && history.weight != staffDetail.weight}">
          <span v-if="history.weight && history.weight != staffDetail.weight">*</span>
          <h4>体重：</h4>
          {{ staffDetail.weight }}kg
          <i
            class="el-icon-view view_history"
            v-popover:popover19
            v-show="history.weight && history.weight!= staffDetail.weight"
          ></i>
          <!-- 显示 -->
          <el-popover
            ref="popover19"
            placement="right"
            title="体重："
            width="200"
            trigger="click"
            :content="history.weight"
          ></el-popover>
        </el-col>

        <el-col :span="6" class="media_col padding-tb10" :class="{'contrast':history.education && history.education != staffDetail.education}">
          <span v-if="history.education && history.education!= staffDetail.education">*</span>
          <h4>学历：</h4>
          {{ staffDetail.education }}
          <i
            class="el-icon-view view_history"
            v-popover:popover8
            v-show="history.education && history.education!= staffDetail.education"
          ></i>
          <!-- 显示 -->
          <el-popover
            ref="popover8"
            placement="right"
            title="学历："
            width="200"
            trigger="click"
            :content="history.education"
          ></el-popover>
        </el-col>
        <el-col :span="6" class="media_col padding-tb10" >
          <h4>是否服役：</h4>
          {{ staffDetail.militaryService }}
        </el-col>
        <el-col :span="6" class="media_col padding-tb10" :class="{'contrast':history.politicalStatus && history.politicalStatus && history.politicalStatus != staffDetail.politicalStatus}">
          <span v-if="history.politicalStatus && history.politicalStatus != staffDetail.politicalStatus">*</span>
          <h4>政治面貌：</h4>
          {{ staffDetail.politicalStatus }}
          <i
            class="el-icon-view view_history"
            v-popover:popover10
            v-show="history.politicalStatus && history.politicalStatus != staffDetail.politicalStatus"
          ></i>
          <!-- 显示 -->
          <el-popover
            ref="popover10"
            placement="right"
            title="政治面貌："
            width="200"
            trigger="click"
            :content="history.politicalStatus"
          ></el-popover>
        </el-col>
        <el-col :span="6" class="media_col padding-tb10 flex_class" :class="{'contrast':history.nativePlace && history.nativePlace != staffDetail.nativePlace}">
          <span v-if="history.nativePlace && history.nativePlace != staffDetail.nativePlace">*</span>
          <h4 class="flex_shrink">户口所在地：</h4>
          <span
            :class="$store.getters.tagsView?'ellipsis':''"
            :title="staffDetail.nativePlace"
          >{{ staffDetail.nativePlace }}</span>
          <i class="el-icon-view view_history" v-popover:popover11 v-show="history.nativePlace && history.nativePlace!= staffDetail.nativePlace"></i>
          <!-- 显示 -->
          <el-popover
            ref="popover11"
            placement="right"
            title="户口所在地："
            width="200"
            trigger="click"
            :content="history.nativePlace"
          ></el-popover>
        </el-col>
        <el-col :span="6" class="media_col padding-tb10 flex_class" :class="{'contrast':history.registered && history.registered != staffDetail.registered}">
          <span v-if="history.registered && history.registered != staffDetail.registered">*</span>
          <h4 class="flex_shrink">籍贯：</h4>
          <span
            :class="$store.getters.tagsView?'ellipsis':''"
            :title="staffDetail.registered"
          >{{ staffDetail.registered }}</span>
          <i class="el-icon-view view_history" v-popover:popover12 v-show="history.registered && history.registered != staffDetail.registered"></i>
          <!-- 显示 -->
          <el-popover
            ref="popover12"
            placement="right"
            title="籍贯："
            width="200"
            trigger="click"
            :content="history.registered"
          ></el-popover>
        </el-col>

        <el-col :span="6" class="media_col padding-tb10 flex_class" :class="{'contrast':history.place && history.place != staffDetail.place}">
          <span v-if="history.place && history.place != staffDetail.place">*</span>
          <h4 class="flex_shrink">居住地址：</h4>
          <span
            :class="$store.getters.tagsView?'ellipsis':''"
            :title="staffDetail.place"
          >{{ staffDetail.place }}</span>
          <i class="el-icon-view view_history" v-popover:popover13 v-show="history.place && history.place != staffDetail.place"></i>
          <!-- 显示 -->
          <el-popover
            ref="popover13"
            placement="right"
            title="居住地址："
            width="200"
            trigger="click"
            :content="history.place"
          ></el-popover>
        </el-col>
        <el-col :span="6" class="media_col padding-tb10 flex_class" :class="{'contrast':history.emergencyContact && history.emergencyContact != staffDetail.emergencyContact}">
          <span v-if="history.emergencyContact && history.emergencyContact != staffDetail.emergencyContact">*</span>
          <h4 class="flex_shrink">紧急联系人：</h4>
          <span
            :class="$store.getters.tagsView?'ellipsis':''"
            :title="staffDetail.emergencyContact"
          >{{ staffDetail.emergencyContact }}</span>
          <i class="el-icon-view view_history" v-popover:popover14 v-show="history.emergencyContact && history.emergencyContact != staffDetail.emergencyContact"></i>
          <!-- 显示 -->
           <el-popover
            ref="popover14"
            placement="right"
            title="紧急联系人："
            width="200"
            trigger="click"
            :content="history.emergencyContact"
          ></el-popover>
        </el-col>
        <el-col :span="6" class="media_col padding-tb10 flex_class" :class="{'contrast':history.emergencyPhone && history.emergencyPhone != staffDetail.emergencyPhone}">
          <span v-if="history.emergencyPhone && history.emergencyPhone != staffDetail.emergencyPhone">*</span>
          <h4 class="flex_shrink">紧急联系人电话：</h4>
          <span
            :class="$store.getters.tagsView?'ellipsis':''"
            :title="staffDetail.emergencyPhone"
          >{{ staffDetail.emergencyPhone }}</span>
          <i class="el-icon-view view_history" v-popover:popover15 v-show="history.emergencyPhone && history.emergencyPhone != staffDetail.emergencyPhone"></i>
          <!-- 显示 -->
          <el-popover
            ref="popover15"
            placement="right"
            title="紧急联系人电话："
            width="200"
            trigger="click"
            :content="history.emergencyPhone"
          ></el-popover>
        </el-col>
        <el-col :span="6" class="media_col padding-tb10 flex_class" :class="{'contrast':history.securityStaffType && history.securityStaffType != staffDetail.securityStaffType}">
          <span v-if="history.securityStaffType && history.securityStaffType != staffDetail.securityStaffType">*</span>
          <h4 class="flex_shrink">资格证类型：</h4>
          <span
            :class="$store.getters.tagsView?'ellipsis':''"
            :title="staffDetail.securityStaffType"
          >{{ staffDetail.securityStaffType?staffDetail.securityStaffType:"暂无" }}</span>
          <i class="el-icon-view view_history" v-popover:popover16 v-show="history.securityStaffType && history.securityStaffType != staffDetail.securityStaffType"></i>
          <!-- 显示 -->
          <el-popover
            ref="popover16"
            placement="right"
            title="资格证类型："
            width="200"
            trigger="click"
            :content="history.securityStaffType"
          ></el-popover>
        </el-col>
        <el-col :span="6" class="media_col padding-tb10 flex_class" :class="{'contrast':history.bank && history.bank != staffDetail.bank}">
          <span v-if="history.bank && history.bank != staffDetail.bank">*</span>
          <h4 class="flex_shrink">开户银行：</h4>
          <span
            :class="$store.getters.tagsView?'ellipsis':''"
            :title="staffDetail.bank"
          >{{ staffDetail.bank?staffDetail.bank:"暂无" }}</span>
          <i class="el-icon-view view_history" v-popover:popover17 v-show="history.bank && history.bank != staffDetail.bank"></i>
          <!-- 显示 -->
          <el-popover
            ref="popover17"
            placement="right"
            title="开户银行："
            width="200"
            trigger="click"
            :content="history.bank"
          ></el-popover>
        </el-col>
        <el-col :span="6" class="media_col padding-tb10 flex_class" :class="{'contrast':history.cardNum && history.cardNum!= staffDetail.cardNum}">
          <span v-if="history.cardNum && history.cardNum!= staffDetail.cardNum">*</span>
          <h4 class="flex_shrink">银行卡号：</h4>
          <span
            :class="$store.getters.tagsView?'ellipsis':''"
            :title="staffDetail.cardNum"
          >{{ staffDetail.cardNum ?staffDetail.cardNum:"暂无" }}</span>
          <i class="el-icon-view view_history" v-popover:popover18 v-show="history.cardNum && history.cardNum!= staffDetail.cardNum"></i>
          <!-- 显示 -->
          <el-popover
            ref="popover18"
            placement="right"
            title="银行卡号："
            width="200"
            trigger="click"
            :content="history.cardNum"
          ></el-popover>
        </el-col>
        <!-- 离职时间以及离职原因 -->
        <el-col
          :span="6"           class="media_col padding-tb10 flex_class"
          v-if="staffDetail.quitStatus == 1"
        >
          <h4 class="flex_shrink">离职时间：</h4>
          <span
            :class="$store.getters.tagsView?'ellipsis':''"
            :title="staffDetail.quitTime"
          >{{ staffDetail.quitTime }}</span>
        </el-col>

        <el-col
          :span="6"           class="media_col padding-tb10 flex_class"
          v-if="staffDetail.quitStatus == 1"
        >
          <h4 class="flex_shrink">离职原因：</h4>
          <span
            :class="$store.getters.tagsView?'ellipsis':''"
            :title="staffDetail.reasons"
          >{{ staffDetail.reasons }}</span>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'CardInfoAudit',
  props: {
    staffDetail: {
      type: Object,
      default: {}
    },
    history: {
      type: Object,
      default: {}
    }
  },
  data () {
    return {
      isCheck: false // 临时
    }
  }
}
</script>

<style lang="scss" scoped>
$color: #409eff;
.contrast {
  color: $color;
}
.view_history {
  cursor: pointer;
  margin-left: 10px;
}
</style>
